import { APP_LANGUAGES } from './constants/appConstants';

export default function urlHasLanguage(
  url: string,
  activeLang: string
): string {
  const tempUrl = url.startsWith('/') ? url : `/${url}`;
  return APP_LANGUAGES.includes(tempUrl.split('/')[1])
    ? tempUrl
    : `/${activeLang}${tempUrl}`;
}
